module.exports = __webpack_public_path__ + "static/media/ipad.d4d1d271.png";